defineDs('DanskeSpil/Domain/PlayTogether/Scripts/Components/ViewInvite',
  [
    'Shared/Framework/Mithril/Scripts/Core/Component',
    'DanskeSpil/Domain/PlayTogether/Scripts/Helpers/Dictionary',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/ViewInvite/Invitation',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/Card/CardFlowHeader',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Clubs/ClubPage'
  ],
  function (Component, PlayTogetherDictionary, Invitation, CardFlowHeader, ClubPage) {

    // Component:
    Component('view-invite', [PlayTogetherDictionary], function (m, route, settings, property) {

      // Components:
      var root = {
        controller: function () {
          this.settings = settings;
          this.property = property;
          this.rootDictionary = PlayTogetherDictionary;
          this.dictionary = this.rootDictionary.get.bind({ prefix: 'ViewInvite/' });
        },

        view: function (controller) {
          return m(ClubPage, { controller }, {
            flowHeader: CardFlowHeader({
              goBack: () => {
                window.history.back();
              },
              helpOverlay: {
                title: controller.dictionary('HelpOverlay/Title'),
                description: controller.dictionary('HelpOverlay/Description'),
                closeButtonLabel: controller.helpOverlayCloseButtonText
              }
            }),
            title: controller.dictionary('Title', { clubName: controller.property('clubPageController')?.clubName()() }),
            description: controller.dictionary('Description', { clubName: controller.property('clubPageController')?.clubName()() }),
            content: Invitation
          });
        }
      };

      // Routes:
      route('/', root);
    });

  });
